module.exports = __webpack_public_path__ + "static/img/title.965f904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page7/title.png
// module id = sqKt
// module chunks = 0